<template>
	<div class="pd-select" v-show="pickerShow">
		<div class="layer">
			<div class="pd-select-head">
				<h2>{{ pickTitle }}</h2>
				<a href="javascript:void(0);" v-on:click="onClose" class="close">取消</a>
				<a href="javascript:void(0);" v-on:click="onSure" class="sure">确定</a>
			</div>
			<div class="pd-select-body">
				<picker ref="pricePicker" :slots='priceData' @change='onPricePick'></picker>
			</div>
		</div>
	</div>
</template>

<script>
	import { Picker } from 'mint-ui'
	import { mapGetters } from 'vuex'
	export default{
		name: 'PriceSelectBox',
		components: {
			Picker
		},
		computed: {
			...mapGetters({
				prod_pkg: 'getSelectedPkg'
			})
		},
		data: () => ({
			'selectedItem': null,
			'pickTitle': '选择价格',
			'pickerShow': false,
			'priceData': []
		}),
		mounted () {
		},
		methods: {
			onPricePick (picker, value) {
				console.log('pick: ', value)
				this.selectedItem = value[0]
			},
			doShowPicker (flag) {
				this.pickerShow = flag
			},
			onClose () {
				this.pickerShow = false
			},
			onSure () {
				if (!this.selectedItem) {
					this.toast('请选择价格')
					return
				}
				this.pickerShow = false
				this.$emit('change', [this.selectedItem])
			},
			setPriceData () {
				console.log('sell price: ', this.prod_pkg.sell_price)
				this.priceData = [{flex: 1, values: this.prod_pkg.sell_price, className: 'slot1', defaultIndex: 0}]
				let it = null
				let self = this
				it = window.setTimeout(function () {
					let setSlotValue = self.$refs.pricePicker.setSlotValue
					setSlotValue(0, self.prod_pkg.sell_price[0])
					console.log('default price: ', self.prod_pkg.sell_price[0])
					console.log(self.prod_pkg.sell_price[0])
					console.log("pick 1---------------")
					self.onPricePick(0, self.prod_pkg.sell_price)
					window.clearTimeout(it)
				}, 100)
			},
			showPicker () {
				if (this.prod_pkg.sell_price) {
					this.pickerShow = true
				}
			}
		}
	}
</script>

<style scoped="">
	.pd-select {
		display: flex;
	}
</style>



// WEBPACK FOOTER //
// src/components/PriceSelectBox.vue